import { NewBox as Box, ContentLoader, useViewport } from "@bca/ui-library";

const LoadingFilters: React.FunctionComponent = () => {
  const viewport = useViewport();

  return (
    <>
      {viewport.lessThan.sm && (
        <Box marginBottom="xl" display="flex" flexDirection="row">
          <ContentLoader
            width="140px"
            height="48px"
            uniqueKey="mobile-any-loader"
          >
            <rect width={80} height={48} rx={24} ry={24}></rect>
            <rect width={80} height={48} x={24} rx={24} ry={24}></rect>
          </ContentLoader>
          <ContentLoader
            width="160px"
            height="48px"
            uniqueKey="mobile-due-loader"
          >
            <rect width={100} height={48} rx={24} ry={24}></rect>
            <rect width={100} height={48} x={24} rx={24} ry={24}></rect>
          </ContentLoader>
          <ContentLoader
            width="140px"
            height="48px"
            uniqueKey="mobile-paid-loader"
          >
            <rect width={90} height={48} rx={24} ry={24}></rect>
            <rect width={90} height={48} x={24} rx={24} ry={24}></rect>
          </ContentLoader>
        </Box>
      )}
      {viewport.greaterThan.sm && (
        <Box marginBottom="xl" display="flex" flexDirection="row">
          <ContentLoader
            width="140px"
            height="48px"
            uniqueKey="nonmobile-any-loader"
          >
            <rect width={100} height={48} rx={24} ry={24}></rect>
            <rect width={100} height={48} x={24} rx={24} ry={24}></rect>
          </ContentLoader>
          <ContentLoader
            width="160px"
            height="48px"
            uniqueKey="nonmobile-due-loader"
          >
            <rect width={120} height={48} rx={24} ry={24}></rect>
            <rect width={120} height={48} x={24} rx={24} ry={24}></rect>
          </ContentLoader>
          <ContentLoader
            width="140px"
            height="48px"
            uniqueKey="mobile-paid-loader"
          >
            <rect width={110} height={48} rx={24} ry={24}></rect>
            <rect width={110} height={48} x={24} rx={24} ry={24}></rect>
          </ContentLoader>
        </Box>
      )}
    </>
  );
};

export default LoadingFilters;
